<template>
  <div class="ptb-10 plr-20">
    <div class="flex">
      <div class="flex-1 bg-ff h-100 flex align-center">
        <div class="flex align-center ml-5 mr-20 ptb-5 cursor">
          <div class="mr-5 decoration-line" ></div>
          <div class="font-bold font-16-f5971d" >工程报价模板</div>
        </div>
      </div>
    </div>
    <div class="mt-10 mb-5 flex flex-wrap">
      <div class="flex align-center mr-5 mb-5 btn-24-bg-ff" @click="addTemplate">
        <img src="/static/images/add.png" class="icon-14 mr-5" alt="">
        <div>新增模板</div>
      </div>
      <el-upload
        class="text-left"
        multiple
        name="file"
        :httpRequest="httpRequestImg"
        :action="upload"
        :show-file-list="false">
        <div class="addBtn cursor mb-10 button">
          <img src="/static/images/daoru.png" class="icon-14 mr-5" alt="">
          <div>导入模板</div>
        </div>
      </el-upload>
    </div>
    <div class="flex flex-wrap">
      <div class="flex-column template mr-20 mb-20 p-20" v-for="(item,index) in template" :key="index">
        <div class="flex">
          <div class="font-18-30313a font-bold"><input type="text" v-model="item.name" @change="inputName(item.name,item)" style="border: none;"></div>
          <div class="flex flex-1 justify-end align-center">
            <span class="mr-5 font-12-30313a">发布</span>
            <el-switch
              style="display: block"
              v-model="item.status"
              @change="changeStatus(item.status, item)"
              active-color="#858585"
              inactive-color="#e2e2e2">
            </el-switch>
          </div>
        </div>
        <div class="flex mt-10 group mb-20">
          <div class="unit flex">到期时间</div>
          <el-date-picker class="flex-1" type="date" placeholder="请选择时间" format="yyyy.MM.dd " :clearable="false" @change="selectTime(item.maturityTime,item)" v-model="item.maturityTime" ></el-date-picker>
        </div>
        <div class="pt-20 flex" style="border-top: 1px dashed #e2e2e2;">
          <div class="flex-column text-left">
            <div class="font-12-b9b9b9">创建人员：{{item.fundName ? item.fundName : '-'}}</div>
            <div class="font-12-b9b9b9">创建时间：{{item.createTime ? Utils.formatTime2(item.createTime) : '-'}}</div>
          </div>
          <div class="flex flex-1 justify-end">
            <button class="btn-30-border-30313a-small mr-10" @click="openTemplate(item)">打开</button>
            <button class="btn-30-border-ff5555-small" @click="deleteTemplate(item)">删除</button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="500px" title="新增工程报价模板" :visible.sync="modelShow" @closed="onCloseClassify">
      <div class="p-20">
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">模板名称：</div>
          <el-input v-model="temName" class="flex-1" placeholder="请输入模板名称"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-bg-f5971d-s" @click="submitTemplate">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'quotaTemplateItem',
  components: {},
  data () {
    return {
      upload: `${this.$store.state.API_URL_9010}/budget/import`,
      isSubmit: false,
      endTime: '',
      temName: '',
      template: [],
      modelShow: false
    }
  },
  created () {
    this.getTemplate()
  },
  mounted () {},
  methods: {
    getTemplate () {
      let params = {
        companyId: this.$store.state.companyId
      }
      this.axios.post('budgetTemplate/list', params).then(res => {
        if (res.data.success) {
          this.template = res.data.data
          this.template.forEach(item => {
            if (item.status === 1) {
              item.status = true
            } else {
              item.status = false
            }
          })
        }
      })
    },
    addTemplate () {
      this.modelShow = true
    },
    httpRequestImg (e) {
      let formData = new FormData()
      let port = ''
      formData.append('file', e.file)
      formData.append('companyId', this.$store.state.companyId)
      port = '/budgetTemplate/import'
      this.axios.post(`${this.$store.state.API_URL_9010}` + port, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.$message({
            message: '导入成功',
            type: 'success'
          })
          this.getTemplate()
        } else {
          this.$message({
            message: onloadRes.data.msg,
            type: 'error'
          })
        }
      }).catch(() => {
        this.$message.error('导入失败！')
      })
    },
    submitTemplate () {
      let params = {
        companyId: this.$store.state.companyId,
        name: this.temName
      }
      if (this.temName) {
        this.axios.post('budgetTemplate/save', params).then(res => {
          if (res.data.success) {
            this.$message({
              message: '添加模板成功',
              type: 'success'
            })
            this.modelShow = false
            this.temName = ''
            this.getTemplate()
          }
        })
      } else {
        this.$message.error('名称不能为空哟')
      }
    },
    inputName (name, item) {
      let data = {}
      data.name = name
      data.id = item.id
      this.axios.post('budgetTemplate/modify', data).then(res => {
        if (res.data.success) {
          this.$message({
            message: '修改模板成功',
            type: 'success'
          })
          this.getTemplate()
        }
      })
    },
    selectTime (time, item) {
      let data = {}
      data.maturityTime = time
      data.id = item.id
      this.axios.post('budgetTemplate/modify', data).then(res => {
        if (res.data.success) {
          this.$message({
            message: '修改模板成功',
            type: 'success'
          })
          this.getTemplate()
        }
      })
    },
    changeStatus (status, item) {
      let a = null
      if (status) {
        a = 1
      } else {
        a = -1
      }
      let data = {}
      data.status = a
      data.id = item.id
      this.axios.post('budgetTemplate/modify', data).then(res => {
        if (res.data.success) {
          this.$message({
            message: '修改模板成功',
            type: 'success'
          })
          this.getTemplate()
        }
      })
    },
    deleteTemplate (item) {
      let data = {
        id: item.id
      }
      this.$confirm(`此操作将删除${item.name}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post('budgetTemplate/deleteById', this.qs.stringify(data)).then(res => {
          if (res.data.success) {
            this.$message({
              message: '删除模板成功',
              type: 'success'
            })
            this.getTemplate()
          }
        })
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onCloseClassify () {
      this.modelShow = false
    },
    openTemplate (item) {
      this.$parent.openDetailShow = true
      this.$parent.selectedTemplate = item
      this.$store.dispatch('setQuotationTemplate', item)
      this.$store.dispatch('setQuotationTemplateId', item.id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .addBtn{
    background: #fff;
    height: 24px;
    color: #30313a;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 4px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .template{
    width: 356px;
    height: 168px;
    border-radius: 4px;
    background: #ffffff;
  }
  .group /deep/ .el-input__prefix{
    padding-left:10px;
    left: auto;
    right: 5px;
  }
  .group /deep/ .el-input__inner{
    padding-left:10px;
    border: 1px solid #e2e2e2;
    border-radius: 0px;
  }
  .unit{
    font-size: 12px;
    color: #b9b9b9;
    border: solid 1px #e2e2e2;
    border-right: 0;
    background-color: #f3f4f7;
    padding:  0 10px;
    height: 30px;
    line-height: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/component/quotaTemplateItem.vue